import React from 'react'
import '../styles/Construction.styles.css'
import Building from '../icons/Building'
import Casa from '../icons/Casa'
import Remodelacion from '../icons/Remodelacion'
import Diseno from '../icons/Diseno'
import { useOnScreen } from "../hooks/useOnScreen";

export default function Construction() {
  const [ref, isVisible] = useOnScreen({ threshold: 0.3 });
  return (
    <section className='construction' id='constructora'>
      <div className='ct-container'>
        <div className='ct_contenido'>
          <div className='ct_contenido1'>
            <div className='ct_infoText'>
              <p>
                TÚ LO SUEÑAS <br/> NOSOTROS LO CONSTRUIMOS
              </p>
            </div>
          </div>
          <div className='ct_contenido2'>
            <div className='divIcons1'>
              <div ref={ref} className={`ct_icon ${isVisible?"is-visible1":""}`}>
                <div className='iconContainer'> 
                  <Casa/>
                </div>
                <div className='textIcon'>
                  <p>
                    CASA HABITACIÓN
                  </p>
                </div>
              </div>
              <div ref={ref} className={`ct_icon ${isVisible?"is-visible2":""}`}>
                <div className='iconContainer'> 
                  <Building/>
                </div>
                <div className='textIcon'>
                  <p>
                    EDIFICIO
                  </p>
                </div>
              </div>
            </div>
            <div className='divIcons2'>
              <div ref={ref} className={`ct_icon ${isVisible?"is-visible3":""}`}>
                <div className='iconContainer'> 
                  <Diseno/>
                </div>
                <div className='textIcon'>
                  <p>
                    DISEÑO DE CONSTRUCCIÓN
                  </p>
                </div>
              </div>
              <div ref={ref} className={`ct_icon ${isVisible?"is-visible4":""}`}>
                <div className='iconContainer'> 
                  <Remodelacion/>
                </div>
                <div className='textIcon'>
                  <p>
                    REMODELACIÓN
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
